module.exports = __webpack_public_path__ + "img/av_egret.605ff296.png";